import { render, staticRenderFns } from "./BaseBreadcrumb.vue?vue&type=template&id=9a3e994a&scoped=true"
import script from "./BaseBreadcrumb.vue?vue&type=script&lang=js"
export * from "./BaseBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./BaseBreadcrumb.vue?vue&type=style&index=0&id=9a3e994a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3e994a",
  null
  
)

export default component.exports